export default __webpack_public_path__ + "static/media/021-rain.121b87b4.svg";